// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_cWZ","cls2":"CiterightInline-cls2_fMQ CiterightInline-cls1_cWZ"};